/* src/app/workshop/components/settings/intervals/intervals.component.scss */
/*# sourceMappingURL=intervals.component.css.map */
